import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useContentConclusion = () => {
  const { t } = useTranslation('Vindoc');
  const LOCK_EMPTY_LINE = useMemo(() => '<p class="mceNonEditable">&nbsp;</p>', []);
  const EMPTY_LINE = useMemo(() => '<p>&nbsp;</p>', []);
  const CONTENT_TITLE = useMemo(
    () => `<p class="mceNonEditable" style="color: red;"><strong>${t('CONTENT')}: </strong></p>`,
    [t]
  );
  const CONCLUSION_TITLE = useMemo(
    () => `<p class="mceNonEditable" style="color: red;"><strong>${t('CONCLUSION')}: </strong></p>`,
    [t]
  );

  return { LOCK_EMPTY_LINE, EMPTY_LINE, CONTENT_TITLE, CONCLUSION_TITLE };
};

export default useContentConclusion;
